export class Kge {
    idKge!: number;
    bezeichnung!: string; 
    kge!: number;  
    nutzungsdauer!: string;
   }
